angular.module( 'acme.view.application.programs.modals.confirmUpdateEvent', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.programs.modals.confirmUpdateEvent.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var programsModalsConfirmUpdateEvent = {
        name: 'application.programs.modals.confirmUpdateEvent',
        url: '/programs/modals/confirmUpdateEvent',
        views: {
          "main": {
            controller: 'ProgramsModalsConfirmUpdateEventController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/programs/modals/confirmUpdateEvent/confirmUpdateEvent.tpl.html'
          }
        },
        data: {
          pageTitle: '   '
        }
      };

    $stateProvider
      .state(programsModalsConfirmUpdateEvent);
});
